/**
 * Returns the ordinal suffix for a number.
 * @param {number} num - The number to get the ordinal suffix for.
 * @returns {string} The ordinal suffix.
 */
export const getOrdinal = (num) => {
	if (!Number.isInteger(num)) {
		return '';
	}

	const absNum = Math.abs(num);

	const lastTwoDigits = absNum % 100;

	if (
		lastTwoDigits >= 11
		&& lastTwoDigits <= 13
	) {
		return 'th';
	}

	switch (absNum % 10) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};

/**
 * Appends the ordinal suffix to a number.
 * @param {number} num - The number to append the ordinal suffix to.
 * @returns {string} The number with the ordinal suffix appended.
 */
export const nth = (num) => {
	return num + getOrdinal(num);
};
